import { downloadFile, get, post, uploadFile } from '@/http/axios';

/**
 * UDSV2诊断
 */

/**
 * 获取设备是否在线
 * @param {*} params
 * @returns
 */
export function getDeviceInfo(params) {
  return get({
    url: '/tsp-collect-data/udsTask/v2/getDeviceInfo',
    params,
    hasLoading: true
  });
}

/**
 * 新建任务
 * @param {*} params
 * @returns
 */
export function udsAddTask(data) {
  return post({
    url: '/tsp-collect-data/udsTask/v2/add',
    data,
    hasLoading: true
  });
}


/**
 * 新建任务
 * @param {*} params
 * @returns
 */
export function udsTaskResult(data) {
  return post({
    url: '/tsp-collect-data/udsTask/v2/queryResult',
    data,
    hasLoading: true
  });
}


/**
 * 查询结果项
 * @param {*} params
 * @returns
 */
export function getUdsItemList(params) {
  return get({
    url: '/tsp-collect-data/udsRecord/v2/item/page',
    params,
    hasLoading: true
  });
}


/**
 * 导出结果项
 * @param {*} params
 * @returns
 */
export function exportUdsItemList(params) {
  return get({
    url: '/tsp-collect-data/udsRecord/v2/item/export',
    params,
    hasLoading: true
  });
}


/**
 * 查询单车诊断记录单页面
 * @param {*} params
 * @returns
 */
export function getUdsCheckList(params) {
  return get({
    url: '/tsp-collect-data/udsRecord/v2/page',
    params,
    hasLoading: true
  });
}



/**
 * 查询
 * @param {*} params
 * @returns 根据诊断记录id查看详情
 */
export function getUdsCheckDetials(params) {
  return get({
    url: '/tsp-collect-data/udsRecord/v2/details',
    params,
    hasLoading: true
  });
}


